<template>
  <v-row>
    <v-col cols="12" class="mt-0 mb-1 pb-0 pt-2">
      <v-file-input
        clearable
        class="flex-md-grow-1"
        dense
        outlined
        autocomplete="off"
        :label="label"
        :prepend-icon="icon"
        :disabled="disabled"
        @change="on_change"
      />
    </v-col>
  </v-row>
</template>

<script>
export default {
  name: "ImageField",
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      default: "",
    },
    icon: {
      type: String,
      default: "mdi-pencil",
    },
    folder: {
      type: String,
      default: "",
    },
    default_value: {
      type: String,
      default: "",
    },
    clear_cache_on_success: {
      type: Boolean,
      default: true,
    },
    required: {
      type: Boolean,
      default: false,
    },
    empty_file_error: {
      type: String,
      default: "No file file choosen",
    },
  },
  data: () => {
    return {
      selected_file: null,
    };
  },
  methods: {
    on_change(file) {
      if (file) {
        this.selected_file = file;
      }
    },
    upload_file() {
      //https://medium.com/js-dojo/upload-files-to-cloudinary-using-vue-vuetify-dd45472c4fd6
      //croping files
      //https://lobotuerto.com/blog/cropping-images-with-vuejs-and-cropperjs/
      if (this.selected_file) {
        this.$emit("on-show-loader");
        this.send_file_to_cloudinary(this.selected_file,this.folder)
          .then((res) => {
            this.$emit("on-hide-loader");
            this.$emit("on-success", res.secure_url);
            if(this.clear_cache_on_success){
              this.selected_file = null;
            }
          })
          .catch((errors) => {
            this.$emit("on-hide-loader");
            this.$emit("on-error", errors);
          });
      }else{
        if(this.required == true && this.default_value.length == 0 ){
          this.$emit("on-error", [this.empty_file_error]);
        }else{
          this.$emit("on-success", this.default_value);
        }
      }
    },
    send_file_to_cloudinary(file,folder) {
      return new Promise(function (resolve, reject) {
        //Ideally these to lines would be in a .env file
        const CLOUDINARY_URL =
          "https://api.cloudinary.com/v1_1/solidcare-img-cloud/image/upload";
        const CLOUDINARY_UPLOAD_PRESET = "szndmsby";

        let formData = new FormData();
        formData.append("upload_preset", CLOUDINARY_UPLOAD_PRESET);
        formData.append("folder", "/botswana services/" + folder);
        formData.append("file", file);

        let request = new XMLHttpRequest();
        request.open("POST", CLOUDINARY_URL, true);
        request.setRequestHeader("X-Requested-With", "XMLHttpRequest");
        request.onreadystatechange = () => {
          // File uploaded successfully
          if (request.readyState === 4 && request.status === 200) {
            let response = JSON.parse(request.responseText);
            resolve(response);
          }

          // Not succesfull, let find our what happened
          if (request.status !== 200) {
            if(request.responseText == ""){
              reject(["Propabaly request timeout, please check your internet connection and try again"]);
            }else{
              try{
                console.log("my res ", request);
                let response = JSON.parse(request.responseText);
                let error = response.error.message;
                // alert("error, status code not 200 " + error);
                reject([error]);
              }catch(errorx){
                console.log("my exception ", errorx);
                reject([errorx.message]);
              }
            }

            
          }
        };

        request.onerror = (err) => {
          // alert("error: " + err);
          reject([err]);
        };

        request.send(formData);
      });
    },
  }
};
</script>